import { render, staticRenderFns } from "./IconSvgForumCommunity.vue?vue&type=template&id=ab7ebc1e&scoped=true&"
import script from "./IconSvgForumCommunity.vue?vue&type=script&lang=js&"
export * from "./IconSvgForumCommunity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab7ebc1e",
  null
  
)

export default component.exports